<template>
  <div
    v-if="description.length"
    class="p-4 overflow-auto bg-gray-200 rounded-md max-h-[32rem] overflow-auto whitespace-pre-wrap"
  >
    <p class="text-left" v-html="cleanedDescription"></p>
  </div>
</template>
<script>
import { defineComponent, computed } from "vue";

export default defineComponent({
  props: {
    description: {
      type: String,
      required: true,
      default: ""
    },
    withDescription: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    function fixEncoding(text) {
      return text
        .replace(/Ã—/g, "×")
        .replace(/â€“/g, "–")
        .replace(/â€”/g, "—")
        .replace(/â€˜/g, "‘")
        .replace(/â€™/g, "’")
        .replace(/â€œ/g, "“")
        .replace(/â€/g, "”")
        .replace(/Â/g, "")
        .replace(/Ã/g, "à");
    }

    function addLineBreaks(text) {
      return text.replace(/\. (?=[A-Z])/g, ".\n").replace(/\\\//g, "/");
    }

    const cleanedDescription = computed(() =>
      addLineBreaks(fixEncoding(props.description))
    );

    return {
      cleanedDescription
    };
  }
});
</script>
<style scoped />
